import { Exclude, Transform, Type } from 'class-transformer';

import { booleanTransform, centTransform, dateTransform } from '../utils/helper';
import { Actor } from './actor.model';
import { InsDate } from './date.model';
import { OfferPayMode } from './offer.model';
import { Tipologiaintervento } from './tipologiaintervento.model';
import { Veicolo } from './veicolo.model';

export class ServiceInstance extends InsDate {
	id?: number;
	@Transform(dateTransform)
	startdate?: Date;
	@Transform(dateTransform)
	enddate?: Date;
	pickup?: string;
	dropoff?: string;
	periodicserviceid?: number;
	driverid?: number;
	seconddriverid?: number;
	vehicleid?: number;
	hqid?: number;
	patientid?: number;
	paymentmethod?: string;
	payerid?: number;
	servicetype?: string;
	status?: string;
	@Transform(booleanTransform)
	periodicflag?: boolean;
	periodicitemid?: number;
	@Transform(centTransform)
	servicecontribution?: number; // Contr. Serv.
	@Transform(centTransform)
	serviceamount?: number;
	prevserviceamount?: number;
	shareamount?: number;
	amountvolunteer?: number;
	@Transform(centTransform)
	refunddriver?: number; // Rimb. Ope.
	@Transform(centTransform)
	kmcovered?: number;
	@Transform(dateTransform)
	bookingdate?: Date;
	bookingnumber?: number;
	@Transform(booleanTransform)
	ritorno?: boolean;
	@Transform(dateTransform)
	ritornodate?: Date;
	idpartenza?: number;
	idritorno?: number;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	driver?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Tipologiaintervento)
	servicetypemodel?: Tipologiaintervento;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	seconddriver?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Veicolo)
	vehicle?: Veicolo;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	payer?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	patient?: Actor;

	get isCompleted() {
		return this.status === ServiceInstanceStatus.COMPLETED;
	}

	get isBooked() {
		return this.status === ServiceInstanceStatus.BOOKED;
	}

	get isCanceled() {
		return this.status === ServiceInstanceStatus.CANCELED;
	}

	get isCash() {
		return this.paymentmethod === OfferPayMode.PAYMENT_METHOD_CASH;
	}
}

export class ServiceInstanceTotals {
	@Transform(centTransform)
	total?: number;
	@Transform(centTransform)
	refundTotal?: number;
	@Transform(centTransform)
	balance?: number;
}

export enum ServiceInstanceStatus {
	COMPLETED = 'completed',
	BOOKED = 'booked',
	CANCELED = 'canceled'
}
